import { Box, useMantineTheme } from '@mantine/core';
import { keyframes } from '../utils/keyframes';;
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

const pulseKeyframes = keyframes({
  '0%': { transform: 'scale(0)', opacity: 1 },
  '100%': { transform: 'scale(1)', opacity: 0 },
});

export interface PulseLoaderProps {
  size?: number;
  color?: string;
  gradientVariant?: 'primary' | 'secondary' | 'tertiary';
  speed?: number;
  rings?: number;
}

const PulseLoader = forwardRef<HTMLDivElement, PulseLoaderProps>(
  (
    {
      size = 40,
      color,
      gradientVariant = 'primary',
      speed = 1500,
      rings = 2,
    },
    ref
  ) => {
    const theme = useMantineTheme();
    const reducedMotion = useReducedMotion();
    const gradient = theme.other?.gradients?.[gradientVariant];
    const ringColor = color || gradient?.from || theme.primaryColor;

    return (
      <Box
        ref={ref}
        style={{
          position: 'relative',
          width: size,
          height: size,
        }}
      >
        {Array.from({ length: rings }, (_, i) => (
          <Box
            key={i}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              border: `2px solid ${ringColor}`,
              animation: reducedMotion
                ? 'none'
                : `${pulseKeyframes} ${speed}ms ease-out ${(i * speed) / rings}ms infinite`,
            }}
          />
        ))}
      </Box>
    );
  }
);

PulseLoader.displayName = 'PulseLoader';

export default PulseLoader;
